import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mandatory" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "q-gutter-sm flex column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_validity_form = _resolveComponent("validity-form")!
  const _component_attachment_form = _resolveComponent("attachment-form")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_select_mandatory_fields = _resolveComponent("select-mandatory-fields")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    loading: _ctx.loading,
    title: _ctx.cda ? _ctx.t('TITLE.ADD', { object: _ctx.t('CDA') }) : _ctx.t('TITLE.ADD', { object: _ctx.t('AGREEMENT.LOW.SING') }),
    onCancel: _ctx.revertStep,
    onConfirm: _ctx.nextStep,
    "form-width": "700",
    "disable-confirm": _ctx.disableConfirm,
    "confirm-label": _ctx.confirmBtnLabel,
    "cancel-label": _ctx.cancelBtnLabel,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_stepper, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.step) = $event)),
        flat: "",
        "keep-alive": "",
        color: "primary",
        contracted: "",
        animated: "",
        "header-class": "hidden",
        class: "agreement-stepper",
        ref: "stepper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_step, {
            name: _ctx.AgrFormSteps.BASIC_AGREEMENT,
            title: _ctx.t('STEP.INFORMATION'),
            done: _ctx.step > 1,
            editable: _ctx.step > 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "bg-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_form, {
                    id: "agreement-form",
                    ref: "agreementForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "column q-mx-sm" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-sm q-pb-md" }), _toDisplayString(_ctx.t('DEFINITION')), 17),
                          _createVNode(_component_q_input, _mergeProps({ autofocus: "" }, _ctx.INPUT_LG, {
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                            "label-slot": "",
                            class: "full-width",
                            placeholder: _ctx.t('NAME.PLACEHOLDER'),
                            rules: [(val) => val?.trim().length > 0 && val?.trim().length <= _ctx.MAX_LENGTH.AGREEMENT.NAME]
                          }), {
                            label: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('NAME.LABEL')) + " ", 1),
                              _hoisted_1
                            ]),
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.name?.trim().length > 0
                                                    ? _ctx.t('NAME.ERROR.LONG', { x: _ctx.MAX_LENGTH.AGREEMENT.NAME })
                                                    : _ctx.t('VALIDATION.REQUIRED.SING', { attribute: _ctx.t('NAME.LABEL') })), 1)
                            ]),
                            _: 1
                          }, 16, ["modelValue", "placeholder", "rules"]),
                          _createVNode(_component_iuf_select, _mergeProps({
                            modelValue: _ctx.type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                            label: _ctx.t('TYPE.LABEL'),
                            loading: _ctx.loadingTypes,
                            rules: [_ctx.validateAgreementType]
                          }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                            options: _ctx.typeOptions,
                            "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
                            mandatory: "",
                            "option-label": "label",
                            "option-value": "dobjId",
                            "selected-item-slot": "",
                            onFilter: _ctx.searchTypes
                          }), {
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('VALIDATION.REQUIRED.SING', { attribute: _ctx.t('TYPE.LABEL') })), 1)
                            ]),
                            "selected-item": _withCtx((scope) => [
                              _createVNode(_component_iap_chip, {
                                tooltip: "",
                                label: scope.opt.label
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }, 16, ["modelValue", "label", "loading", "rules", "options", "placeholder-value", "onFilter"]),
                          _createVNode(_component_iuf_select, _mergeProps({
                            modelValue: _ctx.companies,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companies) = $event)),
                            label: _ctx.t('COMPANIES.LABEL'),
                            loading: _ctx.loadingCompanies,
                            rules: [_ctx.validateCompanies]
                          }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                            options: _ctx.companyOptions,
                            "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                            mandatory: "",
                            "option-label": "name",
                            "option-value": "dobjId",
                            "selected-item-slot": "",
                            onFilter: _ctx.searchCompanies
                          }), {
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('VALIDATION.REQUIRED.PLUR', { attribute: _ctx.t('COMPANIES.LABEL') })), 1)
                            ]),
                            "selected-item": _withCtx((scope) => [
                              _createVNode(_component_iap_chip, {
                                tooltip: "",
                                icon: _ctx.ICONS_NAME.COMPANY_OUTLINE,
                                label: scope.opt.name,
                                removable: "",
                                onRemove: ($event: any) => (scope.toggleOption(scope.opt))
                              }, null, 8, ["icon", "label", "onRemove"])
                            ]),
                            _: 1
                          }, 16, ["modelValue", "label", "loading", "rules", "options", "placeholder-value", "onFilter"]),
                          _createVNode(_component_iuf_select, _mergeProps({
                            modelValue: _ctx.leads,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.leads) = $event))
                          }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                            label: _ctx.t('LEAD.CAP.PLUR'),
                            options: _ctx.leadOptions,
                            rules: [_ctx.validateLeads],
                            "option-label": "name",
                            "selected-item-slot": "",
                            "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                            "option-value": "dobjId",
                            mandatory: !!_ctx.defaultLead,
                            onFilter: _ctx.leadsSearch
                          }), {
                            "selected-item": _withCtx((scope) => [
                              _createVNode(_component_iap_chip, {
                                tooltip: "",
                                icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                                label: scope.opt.name,
                                removable: "",
                                onRemove: ($event: any) => (scope.toggleOption(scope.opt))
                              }, null, 8, ["icon", "label", "onRemove"])
                            ]),
                            _: 1
                          }, 16, ["modelValue", "label", "options", "rules", "placeholder-value", "mandatory", "onFilter"]),
                          _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-lg q-pb-md" }), _toDisplayString(_ctx.t('VALIDITY')), 17),
                          _createVNode(_component_iuf_select, _mergeProps({
                            modelValue: _ctx.status,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event))
                          }, _ctx.SELECT_SINGLE_LG, {
                            label: _ctx.t('STATUS.LABEL'),
                            options: _ctx.availableStatuses,
                            "no-tooltip": "",
                            mandatory: "",
                            "no-option-slot": "",
                            "selected-item-slot": ""
                          }), {
                            "selected-item": _withCtx((scope) => [
                              _createVNode(_component_iap_chip, {
                                tooltip: "",
                                "uncut-label": "",
                                class: "q-pr-xs",
                                icon: _ctx.agreementStatusIcon(scope.opt),
                                "icon-color": _ctx.agreementStatusColorClass(scope.opt),
                                label: _ctx.agreementStatusLabel(scope.opt)
                              }, null, 8, ["icon", "icon-color", "label"])
                            ]),
                            option: _withCtx((scope) => [
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: _ctx.agreementStatusIcon(scope.opt),
                                    color: _ctx.agreementStatusColorClass(scope.opt)
                                  }, null, 8, ["name", "color"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.agreementStatusLabel(scope.opt)), 1)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(Object.assign({}, _ctx.TOOLTIP_PROPS, { anchor: 'bottom middle', self: 'top middle', offset: [0, 4] }))), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.agreementStatusLabel(scope.opt)), 1)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 16, ["modelValue", "label", "options"]),
                          _createVNode(_component_validity_form, {
                            "effective-date": _ctx.effectiveDate,
                            "onUpdate:effectiveDate": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.effectiveDate) = $event)),
                            "expiration-date": _ctx.expirationDate,
                            "onUpdate:expirationDate": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expirationDate) = $event))
                          }, null, 8, ["effective-date", "expiration-date"]),
                          _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-lg q-pb-md" }), _toDisplayString(_ctx.t('DOCUMENT')), 17),
                          _createVNode(_component_attachment_form, {
                            "onUpdate:format": [
                              _ctx.updateFormat,
                              _cache[11] || (_cache[11] = ($event: any) => ((_ctx.format) = $event))
                            ],
                            "onUpdate:type": _ctx.updateType,
                            "onUpdate:link": _ctx.updateLink,
                            "onUpdate:label": _ctx.updateLabel,
                            "onUpdate:file": [
                              _ctx.updateFile,
                              _cache[7] || (_cache[7] = ($event: any) => ((_ctx.file) = $event))
                            ],
                            file: _ctx.file,
                            "link-label": _ctx.linkLabel,
                            "onUpdate:linkLabel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.linkLabel) = $event)),
                            "link-url": _ctx.linkUrl,
                            "onUpdate:linkUrl": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.linkUrl) = $event)),
                            "link-type": _ctx.linkType,
                            "onUpdate:linkType": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.linkType) = $event)),
                            format: _ctx.format
                          }, null, 8, ["onUpdate:format", "onUpdate:type", "onUpdate:link", "onUpdate:label", "onUpdate:file", "file", "link-label", "link-url", "link-type", "format"]),
                          (_ctx.activeMasterAgreementsIdList.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-lg q-pb-md" }), _toDisplayString(_ctx.t('MASTER_OBJECT.CAP', { object: _ctx.t('AGREEMENT.LOW.PLUR') })), 17),
                                _createElementVNode("span", null, _toDisplayString(_ctx.displayMSALabel), 1),
                                _createVNode(_component_q_checkbox, _mergeProps(_ctx.CHECKBOX_PROPS, {
                                  modelValue: _ctx.linkActiveAgreements,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.linkActiveAgreements) = $event)),
                                  class: "q-mr-sm no-left-space",
                                  label: _ctx.t('LINK_MASTER_AGREEMENTS')
                                }), null, 16, ["modelValue", "label"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["name", "title", "done", "editable"]),
          (_ctx.mandatoryFieldsApply)
            ? (_openBlock(), _createBlock(_component_q_step, {
                key: 0,
                name: _ctx.AgrFormSteps.MANDATORY_FIELDS,
                title: _ctx.t('STEP.SECOND'),
                done: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _mergeProps({ class: "q-mx-lg q-my-md" }, _ctx.TEXT_QUATERNARY_TITLE), _toDisplayString(_ctx.t(`AGREEMENT_CREATION_STEP.MANDATORY`, { agreement: _ctx.t('AGREEMENT.LOW.SING') })), 17),
                  _createVNode(_component_select_mandatory_fields, {
                    step: _ctx.AgrFormSteps.MANDATORY_FIELDS,
                    "mandatory-config-id-list": _ctx.mandatoryConfigIdList,
                    "layout-ids": _ctx.layoutIdList,
                    onCompleteUpdate: _ctx.completeUpdate,
                    onInfogroupDataUpdate: _ctx.infoGroupDataUpdate
                  }, null, 8, ["step", "mandatory-config-id-list", "layout-ids", "onCompleteUpdate", "onInfogroupDataUpdate"])
                ]),
                _: 1
              }, 8, ["name", "title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["loading", "title", "onCancel", "onConfirm", "disable-confirm", "confirm-label", "cancel-label"]))
}